import EditInput from "../EditInput";
import "./index.less";

interface PasswordInputProps {
  isPassWord: boolean;
  password: string;
  disabled: boolean;
  setPassword: (password: string) => void;
}

const PasswordInput = ({
  isPassWord,
  password,
  disabled,
  setPassword,
}: PasswordInputProps) => {
  return (
    isPassWord && (
      <div className="password">
        <div className="label text-3 text-mx-secondary">访问密码</div>
        <EditInput disabled={disabled} initialValue={password} onDone={setPassword} />
      </div>
    )
  );
};

export default PasswordInput;
